/* globals
    $:true,
    jQuery:true,
    Backbone:true,
    Mustache:true,
    Rover:true,
    _:true,
    moment:true
    Url:true
*/

import currentUser from '@rover/globals/currentUser';

import PerformanceMetricsService from '../../services/performance_metrics';

export default Backbone.View.extend({
  el: '[data-view="performance-metrics__glanceview"]',
  template:
    Mustache.TEMPLATES[
      'new_design/account_profile/performance_metrics/performance_metrics_glanceview'
    ],

  // View Event Handlers
  events: {
    click: 'handleGlanceViewClick',
  },

  // Initialize
  // Fetch performance data and render
  initialize(options) {
    const self = this;

    _.bindAll(this, '_getPerformanceMetrics', 'render');

    // View Attrs
    self.performanceMetricsService = new PerformanceMetricsService();
    self.data = {};

    // Check Feature Flag
    if (!options.performanceMetricsEnabled) {
      self.$el.parent().removeClass('no-round');
      self.$el.remove();
      return false;
    }

    // Get Performance Metrics from Service
    self
      ._getPerformanceMetrics()
      .then(metrics => {
        self.data = metrics;

        const serviceSlug = self.data.serviceTypes[0].slug;
        self.data.activePerformanceMetric = self.data.services[serviceSlug]; // Pull active service type to send through to template
        self.$el.removeClass('rover-loading');
        self.data.performanceMetricsUrl = `${
          Rover.urls.profile
        }?ref=glance-view#performance-metrics`;
        self.render();
      })
      .fail(err => {
        self.$el.remove();
      });
  },

  // Fetch Users Performance Metrics from API Endpoint
  _getPerformanceMetrics(apiKey) {
    const self = this;
    return self.performanceMetricsService.fetchPerformanceMetrics();
  },

  render() {
    const self = this;
    self.$el.html(Mustache.render(self.template, self.data));

    Rover.utils.initGAEvents(self.$el);

    return self;
  },

  goToProfile() {
    window.location = `${Rover.urls.profile}#performance-metrics`;
  },

  trackGlanceViewClick() {
    if (currentUser.performanceMetricsEnabled) {
      dataLayer.push({
        event: 'sitterscores-navigate-to-scores',
        origin: 'glanceview-scores',
      });
    }
  },

  handleGlanceViewClick() {
    this.trackGlanceViewClick();
    this.goToProfile();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/performance_feedback_metrics_glanceview.js